import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import {
  MODULE_PATH,
  TASKS,
  DAMAGES_PICKER,
  PENALIZATIONS_PICKER,
  RESERVE_REDUCTIONS_PICKER,
  USERS_PICKER,
  ISSUES,
} from "./routesInterface";

export default [
  {
    path: MODULE_PATH,
    name: "Administration",
    meta: {
      requiresAuth: true,
      notAllowed: [
        "USER",
        "EMPLOYEE",
        "TECHNICIAN",
        "SUPPORT",
        "EXTERNAL_SUPPORT",
      ],
    },
    redirect: { name: "Faqs" },
    component: () => import("@/modules/Administration/Administration"),
    children: [
      // DASHBOARD
      {
        path: "home",
        name: "Index",
        component: () => import("@/modules/Administration/Pages/Index.vue"),
        meta: {
          code: MODULE.ADMINISTRATION.DASHBOARD,
        },
      },
      // DAMAGES
      {
        path: "damages",
        name: "cPicker",
        component: () =>
          import("@/modules/Administration/Pages/Damages/DamagesPicker"),
        meta: {
          breadcrumb: [
            { name: "common.tasks", link: TASKS },
            { name: "common.damagesPicker", link: DAMAGES_PICKER },
          ],
          code: MODULE.ADMINISTRATION.DAMAGES,
        },
      },
      {
        path: "damages/validation",
        name: "Damages",
        component: () =>
          import("@/modules/Administration/Pages/Damages/ValidateDamage.vue"),
        meta: {
          code: MODULE.ADMINISTRATION.DAMAGES,
        },
      },
      // INCIDENCES
      {
        path: "issues",
        name: "IssueManager",
        component: () => import("@/modules/Administration/Pages/IssueManager"),
        meta: {
          code: MODULE.ADMINISTRATION.INCIDENCES,
        },
      },
      // PENALIZATIONS
      {
        path: "penalizations",
        name: "PenalizationsPicker",
        component: () =>
          import(
            "@/modules/Administration/Pages/Penalizations/PenalizationsPicker"
          ),
        meta: {
          breadcrumb: [
            { name: "common.tasks", link: TASKS },
            { name: "common.penalizationsPicker", link: PENALIZATIONS_PICKER },
          ],
          code: MODULE.ADMINISTRATION.PENALIZATIONS,
        },
      },
      {
        path: "penalizations/validation",
        name: "Penalizations",
        component: () =>
          import(
            "@/modules/Administration/Pages/Penalizations/ValidatePenalizations"
          ),
        meta: {
          code: MODULE.ADMINISTRATION.PENALIZATIONS,
        },
      },
      // RESERVE REDUCTIONS
      {
        path: "reserveReductions",
        name: "ValidateReserveReductionsPicker",
        component: () =>
          import(
            "@/modules/Administration/Pages/ReserveReductions/ReserveReductionsPicker"
          ),
        meta: {
          breadcrumb: [
            { name: "common.tasks", link: TASKS },
            {
              name: "common.reserveReductionsPicker",
              link: RESERVE_REDUCTIONS_PICKER,
            },
          ],
          code: MODULE.ADMINISTRATION.RESERVE_REDUCTIONS,
        },
      },
      {
        path: "reserveReductions/validation",
        name: "ReserveReductions",
        component: () =>
          import(
            "@/modules/Administration/Pages/ReserveReductions/ValidateReserveReductions"
          ),
        meta: {
          code: MODULE.ADMINISTRATION.RESERVE_REDUCTIONS,
        },
      },
      // USERS
      {
        path: "users",
        name: "ValidateUserPicker",
        component: () =>
          import("@/modules/Administration/Pages/Users/ValidateUserPicker"),
        meta: {
          breadcrumb: [
            { name: "common.tasks", link: TASKS },
            { name: "common.usersPicker", link: USERS_PICKER },
          ],
          code: MODULE.ADMINISTRATION.USERS,
        },
      },
      {
        path: "users/validation",
        name: "ValidateUser",
        component: () =>
          import("@/modules/Administration/Pages/Users/ValidateUser"),
        meta: {
          code: MODULE.ADMINISTRATION.USERS,
        },
      },
      {
        path: "issues/issues/:id",
        name: "IssueDetail",
        component: () =>
        import("@/flit2go-web-core/components/modules/administration/issues/IssueDetail"),
        meta: {
          code: MODULE.ADMINISTRATION.INCIDENCES,
          
          breadcrumb: [
            { name: "common.tasks", link: TASKS },
            { name: "common.helpDesk", link: ISSUES },

          ],
        },

      }

    ],
  },
];
